module.exports = __webpack_public_path__ + "static/media/liljedal.1cdc06d4.jpeg";